module.exports = __webpack_public_path__ + "img/working-at-home.c9da419f.svg";